import {
  Box,
  Button,
  Collapse,
  Flex,
  HStack,
  IconButton,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import {GiHamburgerMenu} from "@onemind-services-llc/react-icons-ng/gi";
import Logo from "public/brand/logo.png";
import {DesktopNav} from "./components/DesktopNav";
import {MobileNav} from "./components/MobileNav";
import Link from "next/link";
import {NAV_BUTTON} from "./header.constants";
import {BUTTON_VARIANTS} from "@/theme/components/button";
import Image from "next/image";
import SafeView from "../safeView";
import {SearchBar} from "./components/searchBar";

const Header = () => {
  const headerBackground = useColorModeValue("white", "gray.800");
  const headerColor = useColorModeValue("gray.600", "white");
  const {isOpen, onToggle, onClose} = useDisclosure();

  return (
    <Box
      position="fixed"
      top={0}
      width={"100%"}
      zIndex={10}
      borderBottom={1}
      bgColor={"white"}
      borderStyle={"solid"}
      borderColor={useColorModeValue("gray.200", "gray.900")}
    >
      <SafeView>
        <Flex
          width={"100%"}
          maxW={"10xl"}
          bg={headerBackground}
          color={headerColor}
          minH={"93px"}
          align={"center"}
          justifyContent="space-between"
          paddingY={"min(2%, 0.5rem)"}
        >
          <HStack>
            <Box display={{base: "block", md: "none"}}>
              <IconButton
                onClick={onToggle}
                bg={isOpen ? "gray.200" : "transparent"}
                icon={<GiHamburgerMenu />}
                variant={"ghost"}
                title={"Hamburger"}
                aria-label={"Toggle Navigation"}
              />
            </Box>
            <Link href={"/"}>
              <Box width={{base: "130px", md: "169px"}} mr={4}>
                <Image
                  alt="logo"
                  src={Logo}
                  style={{width: "100%", height: "auto", objectFit: "contain"}}
                />
              </Box>
            </Link>
            <Box display={{base: "none", md: "block"}} ml={"30px"}>
              <DesktopNav />
            </Box>
          </HStack>

          <HStack>
            <SearchBar />
            <Box display={{base: "none", md: "block"}}>
              <Button
                as={Link}
                href={NAV_BUTTON.href}
                variant={BUTTON_VARIANTS.BRAND}
                whiteSpace={"normal"}
                textAlign={"center"}
              >
                {NAV_BUTTON.label}
              </Button>
            </Box>
          </HStack>
        </Flex>
      </SafeView>
      <Collapse in={isOpen} animateOpacity>
        <MobileNav onClose={onClose} />
      </Collapse>
    </Box>
  );
};

export default Header;
